import { render, staticRenderFns } from "./FacilityCard.vue?vue&type=template&id=2f5a5189&"
import script from "./FacilityCard.vue?vue&type=script&lang=js&"
export * from "./FacilityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports